<template>
	<b-modal
		scrollable
		no-fade
		ok-only
		no-close-on-esc
		no-close-on-backdrop
		title="Asignar proveedor"
		id="modal-assign-supplier-view"
		size="xl"
		body-class="position-static"
		@close="initData"
		@show="showModal"
		@ok="onSubmit"
	>
		<template>
			<div class="row no-gutters mt-0 pt-0 mb-3">
				<div class="col-12 d-flex align-items-center justify-content-between">
					<h5 class="mb-0">
						Total de servicios actualizados: {{ selected.length }}
					</h5>

					<div>
						<b-badge
							variant="light"
							class="d-flex flex-row align-items-center"
							v-if="selected.length ">
							<b-form-checkbox
								name="check-button"
								switch
								unchecked-value="global"
								value="zonedArea"
								v-model="formMode"
								@change="switchModeForm"
							>
							</b-form-checkbox>
							<span>Modo de asignación: {{isZoneAreaMode ? 'Por zona' : 'Manual'}}</span>
						</b-badge>
					</div>
				</div>
				<div class="col-12 d-flex justify-content-start" v-if="isZoneAreaMode">
					<div class="mt-3 col-12 col-md-4">
						<label for="zoneArea" class="mb-0">Zonas Shuttle Central</label>
						
						<Multiselect
							class="multiselect"
							label="text"
							:loading="loadingZonedArea"
							:selectLabel="null"
							ref="zone-selector"
							group-label="group"
							group-values="options"
							:group-select="false"
							:multiple="false"
							track-by="value"
							:options="zonedAreasOptionsGrouped"
							@remove="searchSuppliers('global')"
							v-model="zonedArea"
						/>
					</div>
					<div class="mt-3 col-12 col-md-4">
						<b-form-group label="Fecha asignación">
							<b-form-datepicker
									locale="es"
									today-button
									v-model="assignDate"
							/>
						</b-form-group>
					</div>
					<div class="col-12 col-md-2 d-flex align-items-end">
						<b-button
							@click="searchSuppliers('zonedArea')"
							size="md"
							:disabled="!zonedArea || !selected.length"
							block
							class="btn-success"
							>Buscar</b-button
						>
					</div>
				</div>
			</div>
			<div v-if="serviceList.length==0" class="container">
				<b-alert show class="text-center">No hay servicios por asignar</b-alert>
			</div>
			<div class="d-flex flex-column w-100 mt-1">
				<div
					class="row no-gutters card card-body mb-1"
					v-for="(service, i) in serviceList"
					:key="i"
				>
					<div class="col-12">
						<div class="d-flex h-100 py-2">
							<div class="flex-grow-1">
								<b class="p-0 m-0 h-100">
									{{ service.ids.length }}
									<span> - Servicio(s) |</span>
									<span> {{ service.serviceName }}</span>
									<span> | </span>
									<b-form-select
										:disabled="!isZoneAreaMode"
										style="width: 150px;"
										size="sm"
										v-model="service.parentServiceCategoryId"
										:options="serviceTypesCategoriesOptions"
									></b-form-select>
									<b-button
										v-if="!service.hideBtnExpand && isZoneAreaMode"
										variant="primary"
										class="ml-2"
										size="sm"
										@click="reloadOneServiceSearch(service)"
									>
										<md-icon icon="refresh" />
									</b-button>
								</b>
							</div>
							<div class="flex-grow-1 text-right"></div>
							<b-button
								v-if="!service.hideBtnExpand"
								@click="openCollapse(service, {preselect: true})"
								size="sm"
								variant="primary"
								class="ml-2 mb-1 mt-0"
							>
								<span
									class="when-opened"
									v-if="service.expanded"
								>
									<md-icon icon="keyboard_arrow_up" />
								</span>
								<span class="when-closed" v-else>
									<md-icon icon="keyboard_arrow_down" />
								</span>
							</b-button>
						</div>
						<div v-if="service.cloneFail">
							<md-icon
								class="icon-btn icon-warning"
								icon="warning">
							</md-icon>
							<small class="font-weight-bold text-danger ml-2">No se pudo clonar el proveedor</small>
						</div>
					</div>
					<div class="col-12 mb-0">
						<b-collapse
							:id="'accordion-' + i"
							:visible="service.expanded"
							class="mt-0"
						>
							<b-table
								v-if="isZoneAreaMode"
								striped
								small
								hover
								show-empty
								responsive="md"
								stacked="sm"
								:items="service.supplierList"
								:fields="fields"
								:busy="service.loadingSupplier && isZoneAreaMode"
							>
								<template #cell(supplierName)="{item}">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <span class="mt-2">
                                            {{item.supplierName}}
                                        </span>
                                        <md-icon
                                            v-b-tooltip.hover title="Copiar este proveedor en todos los servicios"
                                            v-if="item.supplierServiceTypeId && item.selectedModel"
                                            @click.native="cloneSuppliers(service, item)"
                                            class="icon-btn mr-2"
                                            icon="content_copy"></md-icon>
                                    </div>
                                </template>
                                <template #cell(product)="{item}">
                                    <div class="d-flex flex-column my-0 py-0">
                                        <div class="d-flex align-items-center">
                                            <b-form-select
                                                size="md"
                                                text-field="name"
                                                value-field="id"
                                                class="formInputs"
                                                :options="item.serviceTypes"
                                                v-model="item.supplierServiceTypeId"
                                                @input="calculateSupplierCosts(item)"
                                                required
                                            />

                                        </div>
                                        <label
                                            v-if="isItemDiferent(item, service)"
                                            class="message-service mt-0 mb-n1"
                                            >La seleccion es distinto al servicio de la reserva</label
                                        >
										<label
											v-if="isMaxPaxMinor(item, service)"
											class="message-service-old mt-1 mb-n1"
											>
											<b>La capacidad maxima de este vehiculo es menor al vendido</b>
										</label>
                                    </div>
                                </template>
                                <template  v-slot:[`cell(prices.totalService)`]="{item}">
                                    <TdCost
                                        :loading="item.loading"
                                        :error="!item.error"
                                    >
                                        {{ getTotalService(item)}}
                                    </TdCost>
                                </template>
                                <template   v-slot:[`cell(prices.costSuppliers)`]="{item}">
                                    <div class="d-flex align-items-center">
                                        <TdCost
                                        :loading="item.loading"
                                        :error="!item.error"
                                    >
                                        <div>
                                            {{ getCostSuppliers(item)}}
                                        </div>
                                        <div v-if="item.prices.costSuppliersConverted">
                                            <small>
                                                {{ getCostSuppliersConverted(item) }}
                                            </small>
                                        </div>
                                    </TdCost>
                                    <div v-if="hasExceptions(item)" class="d-flex align-items-center" v-b-tooltip.hover title="No se pudo calcular el costo de algunos servicios">
                                        <small class="mr-1" v-if="false"><b>({{(item.prices.exceptions.length)}})</b></small>
                                        <md-icon
                                            @click.native="showException(item, 0)"
                                            class="icon-btn icon-error"
                                            icon="error">
                                        </md-icon>
                                    </div>
									<div v-if="hasUnchargedCost(item)" class="d-flex ml-1 align-items-center" v-b-tooltip.hover title="Reservas sin costo de venta">
										<small class="mr-1" v-if="false"><b>({{(item.prices.unchargedCosts.length)}})</b></small>
                                        <md-icon
                                            @click.native="showException(item, 1)"
                                            class="icon-btn icon-warning"
                                            icon="warning">
                                        </md-icon>
									</div>
									<div v-if="hasRidesWithLoss(item)" class="d-flex ml-1 align-items-center" v-b-tooltip.hover title="Reservas con perdida">
										<small class="" v-if="false"><b>({{(item.prices.ridesWithLoss.length)}})</b></small>
                                        <md-icon
                                            @click.native="showException(item, 2)"
                                            class="icon-btn icon-error __shake"
                                            icon="money_off">
                                        </md-icon>
									</div>
                                    </div>
                                </template>
                                <template v-slot:[`cell(prices.revenue)`]="{item}">
                                    <TdCost
                                        :loading="item.loading"
                                        :error="!item.error"
                                        :danger="item.prices.revenue <= 0"
                                        :success="item.prices.revenue > 0"
                                    >
                                        <div v-html="getRevenue(item)"></div>
                                    </TdCost>
                                </template>
                                <template #cell(selected)="{item}">
                                    <b-spinner
                                        small
                                        v-if="item.loading"
                                        variant="primary"
                                    ></b-spinner>
                                    <div v-else>
                                        <div
                                            v-if="item.supplierServiceTypeId"
                                            class="d-flex flex-row align-items-center justify-content-center my-0 py-0"
                                        >
                                            <b-form-group class="mr-2 pt-2">
                                                <b-form-checkbox
                                                    :unchecked-value="false"
                                                    :value="true"
                                                    v-model="item.selectedModel"
                                                    @change="checked(service, item)"
                                                />
                                            </b-form-group>

                                        </div>
                                        <span v-else>--------</span>
                                    </div>
                                </template>
								<template #custom-foot v-if="!service.loadingSupplier && service.supplierOtherList.length > 0">
                                    <tr>
										<td>
											<div class="d-flex align-items-center">
												<Multiselect
													:selectLabel="null"
													class="multiselect"
													label="supplierName"
													track-by="supplierId"
													:loading="service.loadingSupplier"
													:options="service.supplierOtherList"
													@select="selectOtherSupplier(service)"
													v-model="service.supplierSelected"
												/>
												<md-icon
													v-if="service.supplierSelected && service.selectedModel"
													v-b-tooltip.hover title="Copiar este proveedor en todos los servicios"
													@click.native="cloneSuppliers(service, service)"
													class="icon-btn ml-2"
													icon="content_copy"></md-icon>
											</div>
										</td>
										<td>
											<div class="d-flex flex-column">
												<div class="d-flex align-items-center" 	v-if="service.supplierId">
													<b-form-select
														size="md"
														class="formInputs"
														text-field="name"
														value-field="id"
														:options="service.serviceTypes"
														v-model="service.supplierServiceTypeId"
														@change="calculateSupplierCosts(service)"
													/>
												</div>
												<b-form-select v-else size="md" />
												<label
													v-if="checkIfEqual(service)
													"
													class="message-service mt-0 mb-n1"
													>La seleccion es distinto al servicio de la reserva
												</label>
												<label
													v-if="isMaxPaxMinorOthers(service)"
													class="message-service-old mt-1 mb-n1"
													>
													<b>La capacidad maxima de este vehiculo es menor al vendido</b>
												</label>
											</div>
										</td>
										<td>
											<TdCost
												:loading="service.loading"
												:error="!service.error"
											>
												{{ getTotalService(service)}}
											</TdCost>
										</td>
										<td>
											<div class="d-flex align-items-center">
												<TdCost
													:loading="service.loading"
													:error="!service.error"
												>
													<div>
														{{ getCostSuppliers(service)}}
													</div>
													<div v-if="service.prices.costSuppliersConverted">
														<small>
															{{ getCostSuppliersConverted(service) }}
														</small>
													</div>
												</TdCost>
												<div v-if="hasExceptions(service)" class="d-flex align-items-center" v-b-tooltip.hover title="No se pudo calcular el costo de algunos servicios">
													<small class="mr-1" v-if="false"><b>({{(service.prices.exceptions.length)}})</b></small>
													<md-icon
														@click.native="showException(service, 0)"
														class="icon-btn icon-error"
														icon="error">
													</md-icon>
												</div>
												<div v-if="hasUnchargedCost(service)" class="d-flex ml-1 align-items-center" v-b-tooltip.hover title="Reservas sin costo de venta">
													<small class="mr-1" v-if="false"><b>({{(service.prices.unchargedCosts.length)}})</b></small>
													<md-icon
														@click.native="showException(service, 1)"
														class="icon-btn icon-warning"
														icon="warning">
													</md-icon>
												</div>
												<div v-if="hasRidesWithLoss(service)" class="d-flex ml-1 align-items-center" v-b-tooltip.hover title="Reservas con perdida">
													<small class="" v-if="false"><b>({{(service.prices.ridesWithLoss.length)}})</b></small>
													<md-icon
														@click.native="showException(service, 2)"
														class="icon-btn icon-error __shake"
														icon="money_off">
													</md-icon>
												</div>
											</div>
										</td>
										<td>
											<TdCost
												:loading="service.loading"
												:error="!service.error"
												:danger="service.prices.revenue <= 0"
												:success="service.prices.revenue > 0"
											>
												<div v-html="getRevenue(service)"></div>
											</TdCost>
										</td>
										<td>
											<b-spinner
												small
												v-if="service.loading"
												variant="primary"
											></b-spinner>
											<div v-else>
												<div
													v-if="service.supplierServiceTypeId"
													class="d-flex flex-row align-items-center justify-content-center"
												>
													<b-form-group class="mr-2 mt-2">
														<b-form-checkbox
															:unchecked-value="false"
															:value="true"
															v-model="service.selectedModel"
															@change="checked(service)"
														/>
													</b-form-group>

												</div>
												<span v-else>--------</span>
											</div>
										</td>
									</tr>
								</template>
								<template v-slot:table-busy>
									<TableLoader />
								</template>
							</b-table>

							<b-table
								v-if="!isZoneAreaMode"
								striped
								hover
								small
								class="mb-1 pb-1"
								show-empty
								responsive="md"
								stacked="sm"
								:items="items"
								:fields="fieldsGlobal"
							>
								<template #cell(supplierName)>

									<div class="d-flex align-items-center">
									<Multiselect
										class="multiselect my-0 py-0"
										label="text"
										:selectLabel="null"
										:loading="service.loadingSupplier"
										track-by="value"
										:options="supplierOptions"
										@select="selectGlobalSupplier(service)"
										@remove="service.selectedModel = false"
										v-model="service.supplierSelected"
									/>
									<md-icon
										v-if="service.supplierSelected"
										v-b-tooltip.hover title="Copiar este proveedor en todos los servicios"
										@click.native="cloneSuppliers(service)"
										class="icon-btn ml-2"
										icon="content_copy"></md-icon>
									</div>
								</template>
								<template #cell(product) >

									<div class="d-flex align-items-center">
										<Multiselect
											class="multiselect my-0 py-0"
											label="name"
											:selectLabel="null"
											:loading="service.loadingSupplier"
											track-by="id"
											group-values="list"
											group-label="group"
											:options="service.serviceTypes"
											@select="selectServiceType(service)"
											@remove="service.selectedModel = false"
											v-model="
												service.serviceTypeSelected
											"
										/>
										<md-icon
											v-if="service.serviceTypeSelected"
											v-b-tooltip.hover title="Copiar este producto en todos los servicios"
											@click.native="cloneServices(service)"
											class="icon-btn ml-2"
											icon="content_copy"></md-icon>
									</div>
									<label
										v-if="isDiferent(service)"
										class="message-service mt-0 mb-n1"
										><b>La seleccion es distinto al servicio de
										la reserva</b></label
									>
									<label
										v-if="isMaxPaxMinorManual(service)"
										class="message-service-old mt-0 mb-n1"
										>
										<b>La capacidad maxima de este vehiculo es menor al vendido</b>
									</label>
								</template>
								<template #cell(totalService)>
									<TdCost
										:loading="service.loading"
										:error="!service.error"
									>
										{{ getTotalService(service) }}
									</TdCost>
								</template>
								<template #cell(costSuppliers)>
									<div class="d-flex align-items-center">
										<TdCost
											:loading="service.loading"
											:error="!service.error"
										>
											<div>
												{{ getCostSuppliers(service) }}
											</div>
											<div
												v-if="service.prices.costSuppliersConverted"
											>
												<small>
													{{ getCostSuppliersConverted(service) }}
												</small>
											</div>
										</TdCost>
										<div v-if="hasExceptions(service)" class="d-flex align-items-center mt-2" v-b-tooltip.hover title="No se pudo calcular el costo de algunos servicios">
											<small class="mr-1" v-if="false"><b>({{(service.prices.exceptions.length)}})</b></small>
											<md-icon
												@click.native="showException(service, 0)"
												class="icon-btn icon-error"
												icon="error">
											</md-icon>
										</div>
										<div v-if="hasUnchargedCost(service)" class="d-flex ml-1 align-items-center" v-b-tooltip.hover title="Reservas sin costo de venta">
											<small class="mr-1" v-if="false"><b>({{(service.prices.unchargedCosts.length)}})</b></small>
											<md-icon
												@click.native="showException(service, 1)"
												class="icon-btn icon-warning"
												icon="warning">
											</md-icon>
										</div>

										<div v-if="hasRidesWithLoss(service)" class="d-flex ml-1 align-items-center" v-b-tooltip.hover title="Reservas con perdida">
											<small class="" v-if="false"><b>({{(service.prices.ridesWithLoss.length)}})</b></small>
											<md-icon
												@click.native="showException(service, 2)"
												class="icon-btn icon-error __shake"
												icon="money_off">
											</md-icon>
										</div>
									</div>
								</template>
								<template #cell(revenue)>
									<TdCost
										:loading="service.loading"
										:error="!service.error"
										:danger="service.prices.revenue <= 0"
										:success="service.prices.revenue > 0"
									>
										<div v-html="getRevenue(service)"></div>
									</TdCost>
								</template>
								<template #cell(selected)>
									<b-spinner
										class="mt-2"
										small
										v-if="service.loading"
										variant="primary"
									></b-spinner>
									<div v-else class="mt-2">
										<div
											v-if="service.supplierServiceTypeId"
											class="d-flex flex-row align-items-center justify-content-center"
										>
											<b-form-group class="mr-2">
												<b-form-checkbox
													:unchecked-value="false"
													:value="true"
													v-model="service.selectedModel"
												/>
											</b-form-group>

										</div>
										<span v-else>--------</span>
									</div>
								</template>
							</b-table>
							<div v-if="service.errorPlaces.length > 0" class="message-service mb-2">Lo(s) servicio(s) <strong>{{service.errorPlaces.join(', ')}}</strong> tienen problemas en su origen y/o destino</div>
						</b-collapse>
					</div>
				</div>
			</div>
		</template>
		<b-overlay :show="loading" no-wrap></b-overlay>
		<b-overlay :show="showConfirmation" no-wrap>
			<template #overlay>
				<b-overlay :show="loadingConfirmation"></b-overlay>
				<div v-if="!loadingConfirmation">
					<div class="text-center mb-5">
						<h4 id="form-confirm-label">¿Desea continuar?</h4>
					</div>
					<div v-if="itemsWarning.length > 0">
						<ul>
							<li
								class="text-danger"
								v-for="(war, i) of itemsWarning"
								:key="i"
							>
								<p>
									Lo(s) servicio(s):
									<b>{{ war.services.join(", ") }}</b> tienen
									un proveedor diferente al
									<b>{{ war.supplierName }}</b> que ya se
									encuentra confirmado
								</p>
							</li>
						</ul>
					</div>
					<span v-else
						>Ha seleccionado {{ countSelected }} registros para
						actualizar.</span
					>
					<div class="text-center mt-5">
						<b-button
							variant="outline-danger"
							class="mr-3"
							@click="
								() => {
									showConfirmation = false;
								}
							"
							>Cancelar</b-button
						>
						<b-button variant="outline-success" @click="onConfirm"
							>Confirmar</b-button
						>
					</div>
				</div>
			</template>
		</b-overlay>
		<template #modal-footer="prop">
			<div class="d-flex flex-row align-items-center">
				<b-btn class="mr-2 mt-2" @click="prop.close()" size="md" block>
					Cancelar
				</b-btn>
				<b-button @click="showTool" size="md" block variant="info" class="mr-2">Review</b-button>
				<b-btn size="md" @click="prop.ok()" block variant="primary">
					Guardar
				</b-btn>
			</div>
		</template>
		<b-modal
			scrollable
			no-fade
			ok-only
			no-close-on-esc
			no-close-on-backdrop
			title="Detalles"
			id="modal-exception"
			size="lg"
			hide-footer
			>
			<p class="text-danger text-center">Estas reservas no se estan calculando al costo total de los servicios</p>
			<b-tabs fill v-model="tabIndex">
				<b-tab>
					<template #title>
						<div class="d-flex align-items-center">
							<small class="mr-1"><b>({{(exceptions.length)}})</b></small>
							<md-icon
								class="icon-btn icon-error"
								icon="error">
							</md-icon>
							<span>Reservas con error</span>
						</div>
					</template>
					<b-table striped hover :items="exceptions" :fields="fieldsException">
						<template v-slot:cell(serviceNumber)="row">
							<span><a href="#" @click="openReservation(row.item.serviceNumber)"> {{row.item.serviceNumber }}</a></span>
						</template>
					</b-table>
				</b-tab>
				<b-tab>
					<template #title>
						<div class="d-flex align-items-center">
							<small class="mr-1"><b>({{(unchargedCosts.length)}})</b></small>
							<md-icon
								class="icon-btn icon-warning"
								icon="warning">
							</md-icon>
							<span>Reservas sin costo</span>
						</div>
					</template>
					<b-table striped hover :items="unchargedCosts" :fields="fieldsException">
						<template v-slot:cell(serviceNumber)="row">
							<span><a href="#" @click="openReservation(row.item.serviceNumber)"> {{row.item.serviceNumber }}</a></span>
						</template>
					</b-table>
				</b-tab>
				<b-tab v-if="ridesWithLoss.length>0">
					<template #title>
						<div class="d-flex align-items-center">
							<small class="mr-1"><b>({{(ridesWithLoss.length)}})</b></small>
							<md-icon
								class="icon-btn icon-error"
								icon="attach_money">
							</md-icon>
							<span>Reservas con perdida</span>
						</div>
					</template>
					<b-table striped hover :items="ridesWithLoss" :fields="fieldsException">
						<template v-slot:cell(serviceNumber)="row">
							<span><a href="#" @click="openReservation(row.item.serviceNumber)"> {{row.item.serviceNumber }}</a></span>
						</template>
					</b-table>
				</b-tab>
			</b-tabs>
		</b-modal>

		<FormReservation
			:model-id="resMod.resId"
			v-model="resMod.show"
			formTypeWork="viewForm"
		/>
		<b-sidebar  sidebar-class="sidebar-assignation" :title="'Asignación'" bg-variant="light" shadow right v-model="tool.show" backdrop>
			<AssigmentModule :ridesSelected="selected" :massiveAssignmenItems="tool.forReview" ref="assignationTool" @close="tool.show=false" @done="assignedDone"/>
		</b-sidebar>
	</b-modal>
</template>

<script>
import TdCost from "./TdCost";
import Multiselect from "vue-multiselect";
import TableLoader from './TableLoader'
import { fields,fieldsGlobal,fieldsException, items } from "./constants";
import moment from 'moment'
import FormReservation from "@/components/sections/reservation/formReservation/index";
import AssigmentModule from '@/components/tools/assignment/MainComponent.vue'
export default {
	props: {
		value: Boolean,
		selected: {
			type: Array,
			required: true
		}
	},
	components: { Multiselect, TableLoader, TdCost,FormReservation,AssigmentModule},
	data() {
		return {
			tabIndex: 0,
			formMode: 'zonedArea',
			data: [],
			exceptions: [],
			unchargedCosts: [],
			ridesWithLoss: [],
			zonedArea: null,
			loadingZonedArea: false,
			masterZonedAreasOpt: [],
			masterZonedAreasOptDiscovered:[],
			showConfirmation: false,
			loadingConfirmation: false,
			itemsWarning: [],
			loading: false,
			fieldsException,
			fieldsGlobal,
			fields,
			items,
			serviceList: [],
			assignDate:moment().format("YYYY-MM-DD"),
			resMod:{
				show:false,
				resId:-1
			},
			tool:{
				show:false,
				forReview:[]
			},
		};
	},
	computed: {
		zonedAreasOptionsGrouped(){
			return [
				{group:'Area(s) Encontrada(s)',options: this.masterZonedAreasOptDiscovered},
				{group:'Todas las Areas',options: this.masterZonedAreasOpt}
			]
		},
		supplierOptions() {
			return this.$root.auxVars.suppliersOpts;
		},
		serviceTypesCategoriesOptions() {
			return this.$root.auxVars.serviceTypesCategoriesOpts;
		},
		isZoneAreaMode() {
			return this.formMode === 'zonedArea'
		},
		countSelected() {
			return this.data.reduce((acc, curr) => (acc += curr.ids.length), 0);
		}
	},
	mounted() {
		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ["suppliersOpts", "zonedAreasOpts", "serviceTypesOpts", "serviceTypesCategoriesOpts"]
		});
	},
	methods: {
		openReservation(serviceNumber){
			try{
				let resNumber = serviceNumber.split('-')[0]
				this.resMod.resId = parseInt(resNumber)
				this.resMod.show = true
			}catch(err){
				console.log(err)
			}
		},
		hasExceptions(item) {
			return (item?.prices?.exceptions?.length > 0)
		},
		hasUnchargedCost(item) {
			return (item?.prices?.unchargedCosts?.length > 0 )
		},
		hasRidesWithLoss(item) {
			return (item?.prices?.ridesWithLoss?.length > 0)
		},
		showException({prices}, index) {
			this.unchargedCosts = JSON.parse(JSON.stringify(prices.unchargedCosts))
			this.exceptions = JSON.parse(JSON.stringify(prices.exceptions))
			try{
				this.ridesWithLoss = JSON.parse(JSON.stringify(prices.ridesWithLoss))
			}catch(err){
				console.log(err)
			}
			setTimeout(() => {
				this.tabIndex = index
			}, 0);

			this.$root.$emit(
					"bv::show::modal",
					"modal-exception"
				);
		},
		isDiferent(service) {
			const { supplierServiceTypeId, parentServiceCategoryId,  serviceTypeSelected} = service
			if (!supplierServiceTypeId || !serviceTypeSelected) return false;
			return serviceTypeSelected.serviceTypeCategoryId !== parentServiceCategoryId
		},

		getCurrentCategory(serviceTypes, {supplierServiceTypeId}) {
			return serviceTypes.find(({id}) => id === supplierServiceTypeId)
		},
		checkIfEqual(service) {
			const currentCategory =  this.getCurrentCategory(service.serviceTypes, service)?.serviceTypeCategoryId
			return (currentCategory !== service.parentServiceCategoryId) && service.supplierId
		},
		isItemDiferent(item, service) {
            if (!item.supplierServiceTypeId) return false;
			const currentCategory = this.getCurrentCategory(item.serviceTypes, item)?.serviceTypeCategoryId
            return currentCategory !== service.parentServiceCategoryId
        },

		isMaxPaxMinor(item, service) {
			if (!item.supplierServiceTypeId) return false;
			const currentMaxPax= this.getCurrentCategory(item.serviceTypes, item)?.maxPax
            return currentMaxPax < service.serviceMaxPax
		},

		isMaxPaxMinorManual(service) {
			if (!service.supplierServiceTypeId || !service.serviceTypeSelected) return false;
			return service.serviceTypeSelected.maxPax < service.serviceMaxPax
		},

		isMaxPaxMinorOthers(service) {
			const currentMaxPax =  this.getCurrentCategory(service.serviceTypes, service)?.maxPax
			return currentMaxPax < service.serviceMaxPax
		},

		cloneSuppliers(service, row) {
			this.serviceList.forEach(async item => {
				if (this.isZoneAreaMode) {
					if(item.parentServiceTypeId !== service.parentServiceTypeId) {
						if (!item.expanded) await this.openCollapse(item, {preselect: true})
						let hasSupplierInTable = false
						item.supplierList.forEach((supplier)=>{
							if(supplier.supplierId === row.supplierId) {
								if(supplier.supplierServiceTypeId) {
									supplier.selectedModel = true
								}
								hasSupplierInTable = true
								item.cloneFail = false
							}else{
								supplier.selectedModel = false
							}
						})
						if(!hasSupplierInTable){
							let hasSupplierInOtherList = false
							item.supplierOtherList.forEach(supplier => {
								if(supplier.supplierId === row.supplierId) {
									item.supplierSelected = JSON.parse(JSON.stringify(supplier))
									this.selectOtherSupplier(item, true, true)
									hasSupplierInOtherList = true
									item.cloneFail = false
								}
							})
							if(!hasSupplierInOtherList) {
								item.cloneFail = true
							}
						} else {
							item.selectedModel = false
						}
					} else {
						item.cloneFail = false
					}
				} else {
					if(service.serviceTypeSelected.id !== item.serviceTypeSelected?.id){
						item.supplierSelected = JSON.parse(JSON.stringify(service.supplierSelected))
						this.selectGlobalSupplier(item)
					}
				}
			})

		},
		cloneServices(service) {
			this.serviceList.forEach(item => {
				if (!this.isZoneAreaMode) {
					if(service.parentServiceTypeId !== item.parentServiceTypeId){
						item.serviceTypeSelected = JSON.parse(JSON.stringify(service.serviceTypeSelected))
						this.selectServiceType(item)
					}
				}
			})
		},
		showModal(event) {
			//Si ningun servicio fue seleccionado se cierra el modal
			if (!this.selected.length > 0) {
				this.$root.showAlert("Ningún servicio seleccionado", {
					variant: "danger"
				});
				return event.preventDefault();
			}
			this.getMasterZonedAreas()
			this.zonedArea = null
			this.formMode = 'zonedArea'
			this.preselectZoneArea();
			this.initData();
			this.buildServiceList({
				hideBtnExpand: true
			})
		},

		initData() {
			this.serviceList = [];
			this.data = [];
			this.itemsWarning = [];
			this.tool.forReview=[]
		},
		buildServiceList({hideBtnExpand} = {hideBtnExpand: false}) {
			const serviceList = [];
			const serviceWasBuild = ({ serviceTypeId }) =>
				serviceList.find(b => b.parentServiceTypeId === serviceTypeId);

			this.selected.forEach(service => {
				//Se agrupa la seleccion por serviceTypeId (Tipo de servicio de transporte)
				let serviceBuild =  serviceWasBuild(service);
				if (serviceBuild){
					serviceBuild.ids.push(service.id)
					serviceBuild.tServices.push(service)
					return;
				}
				serviceList.push({
					// Helpers
					parentServiceTypeId: service.serviceTypeId,
					parentServiceCategoryId: service.serviceTypeCategory.id,
					serviceName: service.serviceType.name,
					serviceCategoryName: service.serviceTypeCategory.name,
					serviceMaxPax: service.serviceType.maxPax,

					// Checkbox variable
					selectedModel: false,
					// Model
					ids: [service.id],
					tServices:[service],

					supplierId: "",
					supplierServiceTypeId: "",
					ratePlanId: '',
					//
					prices: {},
					loading: false,
					loadingSupplier: false,
					error: false,
					errorPlaces: [],
					supplierList: [],
					supplierOtherList: [],
					supplierSelected: "",
					serviceTypes: [],
					serviceTypeSelected: "",
					cloneFail: false,
					firstExpanded: true,
					firstFetchPrices: true,
					// Si 'formMode' es 'zonedArea' se contraen los b-collapse
					// para evitar pedir todos los suppliers y sobrecargar el back
					expanded: !this.isZoneAreaMode,
					hideBtnExpand: hideBtnExpand
				});
			});
			this.serviceList = serviceList;
		},

		//Filtrar y obtener IDS con serviceType igual al de la reserva
		filterServiceIds({ serviceTypeId }) {
			return this.selected
				.filter(s => s.serviceTypeId === serviceTypeId)
				.map(({ id }) => id);
		},

		switchModeForm(){
			if(!this.isZoneAreaMode) {
				this.searchSuppliers()
			} else {
				this.initData();
				this.buildServiceList({
					hideBtnExpand: true
				})
			}
		},
		getBestServiceType(serviceTypes, {serviceMaxPax, parentServiceCategoryId}) {
			const servicesAux = serviceTypes.filter(({serviceTypeCategoryId}) => serviceTypeCategoryId === parentServiceCategoryId)
			let oldDiff = Infinity
			let currentDiff = 0
			let supplierServiceTypeId = null
			servicesAux.forEach(({maxPax, id}) => {
				currentDiff = Math.abs(maxPax - serviceMaxPax)
				if(currentDiff < oldDiff) {
					oldDiff = currentDiff
					supplierServiceTypeId = id
				}
			})
			return supplierServiceTypeId
		},
		selectOtherSupplier(service, nextTick = true, selectedModel = false) {
			const executeSelect = () => {
				const {supplierId, ratePlanId} = service.supplierSelected;
				service.serviceTypes = service.supplierSelected.serviceTypes
				service.prices = {};
				service.serviceTypeSelected = null;

				service.supplierId = supplierId;
				service.ratePlanId = ratePlanId;

				if(service.supplierSelected.hasCategoryForReservation) {
					service.supplierServiceTypeId = this.getBestServiceType(
						service.supplierSelected.serviceTypes,
						service
					)
					service.selectedModel = selectedModel
					this.calculateSupplierCosts(service)
				}
			}
			if (nextTick) {
				this.$nextTick(() => executeSelect());
			} else {
				executeSelect();
			}
		},
		getSupplierServices(id) {
			const URL = `/transport-services/search-products-supplier/${id}`
			return this.$root.api.get(URL).then(({data}) => data.map(item => ({
				...item,
				text: item.name,
				value: item.id
			})))
		},
		formatServiceTypes(arr) {
			return arr.map(
				({text, value, maxPax, serviceTypeCategoryId}) => ({maxPax, id: value, name: `[${value}] ${text}`, serviceTypeCategoryId })
			);
		},
		selectGlobalSupplier(service, nextTick = true) {
			const executeSelect = () => {
				const supplierId = service.supplierSelected.value;
				service.supplierId = supplierId;
				service.serviceTypeSelected = null
				service.selectedModel = false
				service.loadingSupplier = true
				this.getSupplierServices(supplierId).then((data) => {
					service.serviceTypes = []
					service.serviceTypes = [
						{
							group: 'Vehiculos del proveedor',
							list: this.formatServiceTypes(data)
						},
						{
							group: 'Otros vehiculos',
							list: this.formatServiceTypes(this.$root.auxVars.serviceTypesOpts)
						},
					]
					const aux = service.serviceTypes[0].list
							.find(({serviceTypeCategoryId}) => serviceTypeCategoryId === service.parentServiceCategoryId) ||
							service.serviceTypes[1].list
							.find(({serviceTypeCategoryId}) => serviceTypeCategoryId === service.parentServiceCategoryId)
					if(aux){
						service.serviceTypeSelected = JSON.parse(JSON.stringify(aux))
						this.selectServiceType(service)
					}
				}).catch(this.$root.handleRequestError)
				.finally(()=>service.loadingSupplier = false)
			}
			if (nextTick) {
				this.$nextTick(() => executeSelect());
			} else {
				executeSelect();
			}
		},

		selectServiceType(service) {
			this.$nextTick(() => {
				service.supplierServiceTypeId =
					service.serviceTypeSelected.id;
				service.ratePlanId = service.serviceTypeSelected.ratePlanId
				if(service.supplierServiceTypeId && service.supplierId){
					service.selectedModel = true;
					this.calculateSupplierCosts(service)
				}
			});
		},

		currency(value) {
			if (value === undefined || value === null || value === "")
				return "---------";
			return "$ " + Intl.NumberFormat("en-US").format(value);
		},

		async reloadOneServiceSearch(service){
			await this.getSuppliersByZonedAreaAndCategoryId(service)
		},

		async openCollapse(service, {preselect}) {
			service.expanded = !service.expanded;
			if(service.firstExpanded) {
				if(this.isZoneAreaMode) {
					await this.getSuppliersByZonedAreaAndCategoryId(service)
					if (service.supplierOtherList.length && preselect) {
						service.supplierSelected = service.supplierOtherList[0]
						this.selectOtherSupplier(service)
					}
				}
				service.firstExpanded = false
			}
			if (service.firstFetchPrices) {
				service.supplierList.forEach(supplier => {
					this.calculateSupplierCosts(supplier)
				})
				if (service.supplierOtherList.length && preselect) {
					service.supplierSelected = service.supplierOtherList[0]
					this.selectOtherSupplier(service)
				}
				service.firstFetchPrices = false
			}
		},

		getTotalService({prices}) {
			return `${this.currency(prices.totalService)} ${prices.currencyService || ""}`
		},

		getCostSuppliers({prices}) {
			return `${this.currency(prices.costSuppliers)} ${prices.supplierCurrency || ""}`
		},

		getCostSuppliersConverted({prices}) {
			return `(${this.currency(prices.costSuppliersConverted)} ${prices.costSuppliersConvertedCurrency || ""})`
		},

		getRevenue({prices}) {
			return `${this.currency(prices.revenue)} ${prices.revenueCurrency || ""} <small><b>(${prices.revenuePercent || 0})%</b></small>`
		},

		async getSuppliersByZonedAreaAndCategoryId(service) {
			const URL = "/transport-services/massive-supplier-search";
			service.loadingSupplier = true

			const serviceIds = service.tServices.map((service) => { 
				return {
					id: service.id, 
					pickupDatetime: service.pickupDatetime, 
					flightDatetime: service.flightDatetime
				}
			})

			await this.$root.api
				.post(URL, {
					zonedAreaId: this.zonedArea.value,
					serviceCategoryId: service.parentServiceCategoryId,
					assignDate: this.assignDate,
					serviceMaxPax:service.serviceMaxPax??0,
					serviceList: serviceIds
				})
				.then(({ data }) => {
					service.errorPlaces = data.errorPlaces || []
					const aux = data.suppliers.map((item => {
						const hasCategoryForReservation = item.serviceTypes
							.find(({serviceTypeCategoryId}) => serviceTypeCategoryId === service.parentServiceCategoryId)
						return {
							...item,
							ids: service.ids,
							prices: {},
							error: false,
							selectedModel: false,
							loading: false,
							supplierServiceTypeId: '',
							hasCategoryForReservation,
							serviceTypes: item.serviceTypes.map(type => ({...type, id: type.id, name: `[${type.id}] ${type.name}`})),
						}
					}))

					service.supplierList = aux.slice(0, 3)
						.map(supplier => {
							return {
								...supplier,
								supplierServiceTypeId: this.getBestServiceType(supplier.serviceTypes, service)
							}
					})

					service.supplierOtherList = aux.slice(3, Infinity)

					this.serviceList.forEach(sl => {
						if(sl.parentServiceCategoryId === service.parentServiceCategoryId) {
							sl.firstExpanded = false
							sl.supplierList = service.supplierList
								.map(list => ({
									...list,
									ids: sl.ids,
									supplierServiceTypeId: this.getBestServiceType(list.serviceTypes, service)
								}))
							sl.supplierOtherList = service.supplierOtherList
								.map(otherList => ({
									...otherList,
									ids: sl.ids
								}))
						}
					})

					service.supplierList.forEach(supplier => {
						this.calculateSupplierCosts(supplier)
					})
					service.firstFetchPrices = false
				})
				.finally(()=>{
					service.loadingSupplier = false
				});
		},

		preselectZoneArea() {
			const fistService = this.selected[0].id
			this.masterZonedAreasOptDiscovered = [];
			this.$root.api
				.get(`transport-services/${fistService}/massive/zoned-area`)
				.then(({data}) => {
					if(!this.$root.isEmpty(data)){
						try{
							this.masterZonedAreasOptDiscovered = data.map((item)=>{
								return {value: item.id, text:item.name}
							});
							this.zonedArea = {...this.masterZonedAreasOptDiscovered[0]}
						}catch(err){
							console.log(err);
						}
					}
					
					/* if(Object.keys(data).length > 0) {
						this.zonedArea = {
							text: data.name,
							value: data.id
						}
					} */
				})
				.catch((e)=> {
					console.error('ERROR => preselect zone', e.message)
				})
		},

		getMasterZonedAreas() {

			if (this.masterZonedAreasOpt.length > 0) {
				return true;
			}
			this.loadingZonedArea = true
			this.$root.api
				.get(`zoned-areas/master`)
				.then(({data})=>{

					data.forEach(zonedArea => {
						this.masterZonedAreasOpt.push({
							text: zonedArea.name,
							value: zonedArea.id
						})
					})
				})
				.catch((e)=> {
					console.error('ERROR => load master zoned areas', e.message)
				}).finally(() => {
					this.loadingZonedArea = false
				})
		},

		async calculateSupplierCosts(item) {
			if(! item.supplierServiceTypeId || !item.supplierId) return
			item.loading = true
			this.$root.api
				.post("/transport-services/massive-supplier-revenue", {
					ids: item.ids,
					supplierServiceTypeId: item.supplierServiceTypeId,
					supplierId: item.supplierId,
					ratePlanId: item.ratePlanId || undefined
				})
				.then(({data}) => {
					item.prices = data || {}
				})
				.finally(() => {
					item.loading = false
				})
		},

		onSubmit(event) {
			event.preventDefault();
			this.data = [];

			const serviceToUpdate = this.getServicesConf();

			if (!serviceToUpdate.length > 0)
				return this.$root.showAlert("No hay servicios seleccionados", {
					variant: "warning"
				});

			this.data = serviceToUpdate;

			this.fetchWarnings();

			this.showConfirmation = true;
		},
		fetchWarnings() {
			this.loadingConfirmation = true;
			this.$root.api
				.post(
					`/transport-services/review/supplier-confirmation`,
					this.data
				)
				.then(({ data }) => {
					this.itemsWarning = JSON.parse(JSON.stringify(data));
				})
				.finally(() => {
					this.loadingConfirmation = false;
				});
		},
		checked(service, row) {
			if (!row) {
				service.supplierList.forEach(supplier => {
					supplier.selectedModel = false
				})
			}else {
				service.selectedModel = false
				service.supplierList.forEach(supplier => {
					if(supplier.supplierId != row.supplierId) supplier.selectedModel = false
				})
			}
		},
		onConfirm() {
			this.showConfirmation = false;
			this.loading = true;

			this.$root.api
				.post(`/transport-services/massive-update-suppliers`, this.data)
				.then(async () => {
					this.$root.showAlert("Actualización exitosa");
					this.$root.$emit(
						"bv::refresh::table",
						"reservations-index-list"
					);
					this.$emit("update:selected", []);
					this.$root.$emit(
						"bv::hide::modal",
						"modal-assign-supplier-view",
						event.target
					);
					await this.initData();
				})
				.catch(err => {
					this.$root.handleRequestError(err);
				})
				.finally(() => {
					this.loading = false;
				});
		},
		async searchSuppliers() {
			this.initData();
			// Se construye la lista de servicios con las listas contraidas
			this.buildServiceList();
			if(this.isZoneAreaMode){
				this.openCollapse(this.serviceList[0], {preselect: true})
			}
		},
		getServicesConf(){
			const serviceToUpdate = []
			this.serviceList.forEach((item) => {
				if(item.selectedModel) {
					serviceToUpdate.push({
						ids: item.ids,
						supplierId: item.supplierId,
						supplierServiceTypeId: item.supplierServiceTypeId
					})
				} else {
					item.supplierList.forEach(supplier => {
						if (supplier.selectedModel) {
							serviceToUpdate.push({
								ids: item.ids,
								supplierId: supplier.supplierId,
								supplierServiceTypeId: supplier.supplierServiceTypeId
							})
							return
						}
					})
				}
			});

			return serviceToUpdate;

		},
		showTool(){
			let servicesConf = this.getServicesConf();
			if(!this.tool.show && this.$root.isEmpty(servicesConf)) {
				this.$root.showAlert("No se ha asignado ningun servicio",{variant:'warning'})
				return;
			}
			this.tool.show      = !this.tool.show;
			this.tool.forReview = servicesConf;
			if(this.tool.show){
				setTimeout(() => {
					this.$refs['assignationTool'].showModuleAssignation('assignation')
				}, 0);
			}
			
			
		},
		assignedDone(){
			this.tool.show = false;
			this.tool.forReview.forEach(item => {
				item.ids.forEach((id)=>{
					let index = this.selected.findIndex(item => {
						return item.id == id
					})
					if (index !== -1) { // Ensure the index is valid
						this.selected.splice(index, 1);
					}
				})
			});

			this.tool.forReview = [];
			this.initData();
			this.buildServiceList();
			this.$root.$emit(
				"bv::refresh::table",
				"reservations-index-list"
			);
			
		}
	}
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="css" scoped>
.fw-normal {
	font-weight: 400;
}
.fw-semibold {
	font-weight: 600;
}
.message-service {
	color: #dc3545;
	font-size: 10px;
	margin-bottom: 0px;
}
.message-service-old {
	color: orange;
	font-size: 10px;
	margin-bottom: 0px;
}
.card-body {
	padding: 0.3rem 1.25rem 0rem 1.25rem !important;
}
.multiselect {
	min-width: 250px;
	/*max-width: 270px;*/
}
.formInputs {
	max-width: 250px;
	margin-top: 0px;
	margin-bottom: 0px;
	padding-top: 0px;
	padding-bottom: 0px;
}
.custom-select {
	height: 35px !important;
}

.icon-btn {
	cursor: pointer;
}
.icon-error {
	font-size: 1.3rem;
	color: red;
}

.icon-warning {
	font-size: 1rem;
	color: orange;
}
::v-deep .modal-content{
	min-height: 80vh !important;
}
</style>

